import React, { PureComponent } from 'react'

import { grant, grantMy } from '../Utils/Service'

class NotesDetails extends PureComponent {
  render () {
    const n = this.props.note
    return (
      <ul className={'row-item ' + n.color}>
        <li>
          <span>Autore</span>
          {n.author}
        </li>
        <li>
          <span>Titolo</span>
          {n.title}
        </li>
        <li>
          <span>Nota</span>
          {
            n.message.split('\n').map((item, key) => {
              return <em key={key}>{item}<br/></em>
            })
          }
        </li>
        <li className="info-buttons">
          {
            (n.share === 0) && (
              <i className="far fa-eye-slash"></i>
            )
          }
          {
            (n.share === 1) && (
              <i className="fas fa-lock"></i>
            )
          }
          {
            (n.share === 2) && (
              <i className="fas fa-globe"></i>
            )
          }
          {
            (grant() && (grantMy(n.owner) || n.share === 2)) && (
              <button className="lnk-edits" onClick={() => this.props.showEdit(n)}><i className="fas fa-edit"></i></button>
            )
          }
          {
            (grant() && (grantMy(n.owner) || n.share === 2)) && (
              <button className="lnk-edits" onClick={() => this.props.showDelete(n)}><i className="fas fa-trash-alt"></i></button>
            )
          }
        </li>
      </ul>
    )
  }
}

export default NotesDetails



// WEBPACK FOOTER //
// ./src/components/Notes/NotesDetails.js